import { useEffect } from "react";

export const useTracking = (
	children: any,
	dependencies: any[],
	condition?: boolean,
	timer?: number,
	callBack?: () => void,
) => {
	const toScroll = () => {
		children.current?.scrollIntoView({ block: "center", behavior: "smooth" });
		callBack && callBack();
	};

	let timerLink: any;
	useEffect(() => {
		if (!condition) return;
		if (timer) {
			// eslint-disable-next-line react-hooks/exhaustive-deps
			timerLink = setTimeout(() => {
				toScroll();
			}, timer);
		} else toScroll();

		return () => {
			clearTimeout(timerLink);
		};
	}, [...dependencies]);
};
